import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { analyticsRanges, type AnalyticsRange } from '../../data/vendoo';
import { EASE_OUT, INDICATOR_SPRING } from '../../utils/motion';
export function AnalyticsDashboardMock() {
  const [range, setRange] = useState<AnalyticsRange>('month');
  const current = analyticsRanges.find(r => r.id === range) ?? analyticsRanges[0];
  return <div className="flex h-full flex-col rounded-2xl bg-surface p-4 md:p-5" data-id="element-600" data-mp="1j0eag0dd3ton">
      <div className="flex h-full flex-col rounded-xl bg-white p-4 shadow-sm" data-id="element-601" data-mp="1ey9e2tvj4iyb">
        <div className="flex items-center justify-between gap-3" data-id="element-602" data-mp="1f0dqy1beosaq">
          <p className="text-sm font-semibold text-fg" data-id="element-603" data-mp="1a69jlgy8ai94">Business analytics</p>
          <div role="radiogroup" aria-label="Date range" className="flex gap-0.5 rounded-lg bg-surface p-0.5" data-id="element-604" data-mp="1599dx75ajhij">
            {analyticsRanges.map(r => <button key={r.id} type="button" role="radio" aria-checked={range === r.id} onClick={() => setRange(r.id)} className={`relative rounded-md px-2.5 py-1 text-[11px] font-medium transition-colors duration-150 ${range === r.id ? 'text-white' : 'text-fg-muted hover:text-fg'}`} data-id="element-605" data-mp="22pon15ht9yij">
                {range === r.id && <motion.span layoutId="vendoo-range" className="absolute inset-0 rounded-md bg-ink" transition={INDICATOR_SPRING} data-id="element-606" data-mp="388sayhlvns38" />}
                <span className="relative" data-id="element-607" data-mp="2z7anufa1yq51">{r.label}</span>
              </button>)}
          </div>
        </div>

        <dl className="mt-4 grid grid-cols-3 gap-2" data-id="element-608" data-mp="2paxs7buy627n">
          {current.kpis.map((kpi, i) => <div key={kpi.label} className={`rounded-lg p-2.5 ${i === 1 ? 'bg-ink-soft' : 'bg-surface'}`} data-id="element-609" data-mp="jhzhtmiryibf" data-mpi={i}>
              <dt className="text-[10px] text-fg-muted" data-id="element-610" data-mp="nke0a5ij7g26">{kpi.label}</dt>
              <dd className="mt-0.5 text-sm font-semibold tabular-nums text-fg" data-id="element-611" data-mp="1wh1bfu1veqmw">{kpi.value}</dd>
            </div>)}
        </dl>

        <p className="mt-5 text-[11px] font-medium text-fg-muted" data-id="element-612" data-mp="1rgwtdzlbdnuk">Sales by marketplace</p>
        <div className="mt-2 flex h-32 items-end gap-3" data-id="element-613" data-mp="1nfl27pmskuk9">
          {current.bars.map((bar, i) => <div key={bar.label} className="flex h-full flex-1 flex-col items-center justify-end gap-1.5" data-id="element-614" data-mp="1ii1qawdkgtvh" data-mpi={i}>
              <motion.div className={`w-full rounded-t-md ${i === 0 ? 'bg-coral' : 'bg-ink'}`} initial={false} animate={{
            height: `${bar.value}%`
          }} transition={{
            duration: 0.3,
            ease: EASE_OUT,
            delay: i * 0.03
          }} data-id="element-615" data-mp="2f6hfgrcrl182" />
              <span className="truncate text-[9px] text-fg-faint" data-id="element-616" data-mp="21gxdvoux6a0c">{bar.label}</span>
            </div>)}
        </div>
      </div>
    </div>;
}